/* unplugin-vue-components disabled */// extracted by mini-css-extract-plugin
export default {"tab_wrap":"tab_wrap-a88094c7","active":"active-a893f0a5"};